<div class="container-fluid bg-card">
  <div class="row">
    <div class="col-md-3 col-12 mt-3">
      <div class="card bg-gray font-white p-3 border-radius-10">
        <div class="fs-18 fw-bold">{{ classDetails?.ClassName }}</div>
        <div class="d-flex gap-2 mt-1"></div>
        @for(trainer of trainerList; track $index){
        <div class="d-flex gap-2 mt-4">
          <img
            [src]="getTrainerProfileImage(trainer)"
            alt="profile"
            class="profile-img profile-image-container border-radius-50 overflow-hidden d-flex align-items-center justify-content-center bg-white"
            (error)="onImgError($event)" />
          <div>
            <div class="fs-14 fw-semibold">{{ trainer.TrainerName }} {{ trainer.TrainerLastName }}</div>
            <div class="fs-12 fw-normal">Coach</div>
          </div>
        </div>
        }
      </div>

      <div class="border-bottom-custom mt-3"></div>

      <div class="fs-14 fw-normal mt-3 mb-3">Device Detail</div>

      <div class="bg-black-opacity font-white p-3 border-radius-10">
        <div class="d-flex gap-2 mt-1">
          <div [innerHtml]="SVG_ICONS.FACE_ICON() | sanitizer : 'html'"></div>
          <div class="fs-14 fw-bold align-self-center">Face Scanner</div>
        </div>
        <div class="font-gray-opacity fs-12 fw-normal mt-2">Face Scanner is connected to the device</div>
        <div class="mt-3">
          <button class="plan-status-btn px-2 d-flex gap-2">
            <div [innerHtml]="SVG_ICONS.ROUTER_ICON() | sanitizer : 'html'"></div>
            <div class="fs-12 fw-bold font-green mt-1">Working</div>
          </button>
        </div>
      </div>

      <div class="bg-black-opacity font-white p-3 border-radius-10 mt-3">
        <div class="fs-14 fw-bold align-self-center">Mode of attendance</div>
        <div class="font-gray-opacity fs-12 fw-normal mt-2">Select mode of attendance from here</div>
        <div class="attendance-toggle d-flex bg-black p-1 mt-3">
          <button class="toggle-btn border-0 font-white pl-3 py-2 px-3 cursor-pointer fw-medium fs-14" [class.active]="selectedMode === 'Automatic'" (click)="selectMode('Automatic')">
            Automatic
          </button>
          <button class="toggle-btn border-0 font-white pl-3 py-2 px-3 cursor-pointer fw-medium fs-14" [class.active]="selectedMode === 'Manual'" (click)="selectMode('Manual')">Manual</button>
        </div>
      </div>
    </div>

    <div class="col-auto d-none d-md-flex justify-content-center">
      <div class="vr-custom"></div>
    </div>

    <div class="col-md-3 col-12">
      <div class="fs-18 fw-bold mt-3">All Members</div>
      <div class="d-flex justify-content-between">
        <div class="mt-2 d-flex gap-2 flex-wrap w-100">
          <div class="status-card text-center d-flex align-items-center justify-content-center bg-dark-custom" [class.selected]="selectedStatus === 'All'" (click)="filterByStatus('All')">
            <div class="title font-gray-opacity">Total</div>
            <div class="count font-white">{{ studentList.length || 0 }}</div>
          </div>
          <div
            class="status-card text-center d-flex align-items-center justify-content-center bg-dark-custom border-green"
            [class.selected]="selectedStatus === 'Present'"
            (click)="filterByStatus('Present')">
            <div class="title font-green">Present</div>
            <div class="count font-white">{{ presentCount || 0 }}</div>
          </div>
          <!-- <div class="status-card text-center d-flex align-items-center  bg-dark-custom border-orange" [class.selected]="selectedStatus === 'Late'" (click)="filterByStatus('Late')">
            <div class="title font-orange">Late</div>
            <div class="count font-white">{{ lateCount || 0 }}</div>
          </div> -->
          <div class="status-card text-center d-flex align-items-center bg-dark-custom border-red" [class.selected]="selectedStatus === 'Absent'" (click)="filterByStatus('Absent')">
            <div class="title font-red">Absent</div>
            <div class="count font-white">{{ absentCount || 0 }}</div>
          </div>
          <div class="status-card text-center d-flex align-items-center bg-dark-custom border-blue" [class.selected]="selectedStatus === 'Pending'" (click)="filterByStatus('Pending')">
            <div class="title font-blue">Pending</div>
            <div class="count font-white">{{ pendingCount || 0 }}</div>
          </div>
        </div>
      </div>
      <div class="mt-3 gap-2 d-flex justify-content-between">
        <div class="d-flex gap-2">
          <input type="file" #fileInput style="display: none" (change)="onFileSelected($event)" accept="image/*" />
          <div
            [innerHTML]="SVG_ICONS.UPLOAD_IMGE_ICON() | sanitizer : 'html'"
            class="cursor-pointer"
            matTooltip="Add Class Image"
            matTooltipPosition="below"
            matTooltipShowDelay="0"
            (click)="fileInput.click()"></div>
          <!-- <button class="btn btn-primary" (click)="fileInput.click()">Add</button> -->
          <!-- <button class="btn btn-primary" (click)="onManualAttendance()">Add</button> -->
          <div
            [innerHTML]="SVG_ICONS.MANUAL_ATTENDANCE_ICON() | sanitizer : 'html'"
            class="cursor-pointer"
            matTooltip="Manual Attendance"
            matTooltipPosition="below"
            matTooltipShowDelay="0"
            (click)="onManualAttendance()"></div>
        </div>
        <div class="d-flex align-items-center gap-2 bg-card-secondary border-radius-10 px-3 py-2 search-box w-100">
          <div [innerHTML]="SVG_ICONS.SEARCH_ICON(25, 25) | sanitizer : 'html'"></div>
          <input type="text" class="bg-card-secondary border-0 font-white fs-14" placeholder="Search Student" [(ngModel)]="searchText" />
        </div>
      </div>
      @if(uploadedImagePreview) {
      <div class="mt-3 d-flex justify-content-end">
        <div class="position-relative">
          <img [src]="uploadedImagePreview" alt="Uploaded Preview" class="border-radius-10" style="max-width: 150px; max-height: 150px; object-fit: cover" />
          <div
            class="position-absolute top-0 end-0 p-1 cursor-pointer bg-white rounded-circle d-flex align-items-center justify-content-center"
            style="width: 20px; height: 20px; transform: translate(30%, -30%); box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1)"
            (click)="uploadedImagePreview = null">
            <div [innerHtml]="SVG_ICONS.CLOSE_ICON() | sanitizer : 'html'"></div>
          </div>
        </div>
      </div>
      } @if(selectedMode === 'Automatic') {
      <div class="mt-3 scrollable-container">
        @for (item of filteredStudentList; track item.StudentID) {
        <div
          class="bg-card-secondary p-3 border-radius-10 mt-3"
          [ngClass]="{
            'border-green': item.attendanceStatus === 'Present' || item.attendanceStatus === 'Attend Late',
            'border-red': item.attendanceStatus === 'Absent'
          }">
          <div class="d-flex justify-content-between">
            <div class="d-flex gap-2">
              <div class="d-flex gap-2">
                <img
                  [src]="getStudentProfileImage(item)"
                  alt="profile"
                  class="profile-img profile-image-container border-radius-50 overflow-hidden d-flex align-items-center justify-content-center bg-white"
                  (error)="onImgError($event)" />
                <div class="align-self-center">
                  <div class="fs-14 fw-bold">{{ item.FirstName || "" }} {{ item.MiddleName || "" }} {{ item.LastName || "" }}</div>
                  <div class="fs-12 fw-normal">#{{ item.StudentID || "" }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-3 d-flex gap-3">
            <div class="d-flex gap-1">
              <div [innerHtml]="SVG_ICONS.CAKE_ICON() | sanitizer : 'html'"></div>
              <div class="fs-12 fw-bold font-gray-opacity mt-1">{{ item.age || "0" }} yr</div>
            </div>
            <div class="d-flex gap-1">
              <div [innerHtml]="SVG_ICONS.HEIGHT_ICON(17, 17) | sanitizer : 'html'"></div>
              <div class="fs-12 fw-bold font-gray-opacity mt-1">{{ item.Height || "" }} cm</div>
            </div>
            <!-- <div class="d-flex gap-1">
              <div [innerHtml]="SVG_ICONS.MEMBERSHIP_ICON() | sanitizer : 'html'"></div>
              <div class="fs-12 fw-bold font-gray-opacity mt-1">{{ classDetails.PackageName || "-" }}</div>
            </div> -->
          </div>
        </div>
        }
      </div>
      } @if(selectedMode === 'Manual') {
      <div class="scrollable-container mt-3">
        @if(hasAbsentStudents()) {
        <div class="mt-3">
          <button class="plan-status-btn w-100 py-3 border-radius-10" (click)="AddMarkAllAsPresent()">
            <div [innerHtml]="SVG_ICONS.CHECK_ICON(24, 24) | sanitizer : 'html'"></div>
            <div class="align-self-center font-white ms-1">Mark all as present</div>
          </button>
        </div>
        } @for (item of filteredStudentList; track item.StudentID) {

        <div
          class="bg-card-secondary p-3 border-radius-10 mt-3"
          [ngClass]="{
            'border-green': item.attendanceStatus === 'Present' || item.attendanceStatus === 'Attend Late',
            'border-red': item.attendanceStatus === 'Absent'
          }">
          <div class="d-flex justify-content-between">
            <div class="d-flex gap-2">
              <img
                [src]="getStudentProfileImage(item)"
                alt="profile"
                class="profile-img profile-image-container border-radius-50 overflow-hidden d-flex align-items-center justify-content-center bg-white"
                (error)="onImgError($event)" />
              <div class="align-self-center">
                <div class="fs-14 fw-bold">{{ item.FirstName || "" }} {{ item.MiddleName || "" }} {{ item.LastName || "" }}</div>
                <div class="fs-12 fw-normal">#{{ item.StudentID || "" }}</div>
              </div>
            </div>

            <div class="d-flex align-items-center gap-2">
              <div class="d-flex flex-column align-items-end me-1">
                <div class="d-flex gap-1 align-items-center">
                  <input
                    type="checkbox"
                    [id]="'late_' + $index"
                    [(ngModel)]="item.isLate"
                    [disabled]="item.attendanceStatus === 'Present' || item.attendanceStatus === 'Attend Late'"
                    (change)="onLateStatusChange(item)"
                    class="form-check-input cursor-pointer"
                    style="width: 14px; height: 14px; margin-top: 0" />
                  <label [for]="'late_' + $index" class="fs-12 font-gray-opacity cursor-pointer mb-0">Late?</label>
                </div>
                @if(item.isLate) { @if(availableTimeSlots.length > 0) {
                <select [(ngModel)]="item.lateTime" class="form-select form-select-sm mt-1 p-0 px-1" style="width: 85px; height: 26px; font-size: 11px">
                  @for(time of availableTimeSlots; track time) {
                  <option [value]="time">{{ time }}</option>
                  }
                </select>
                } @else {
                <input
                  type="time"
                  [(ngModel)]="item.lateTime"
                  [min]="todayClassStartTime"
                  [max]="todayClassEndTime"
                  class="form-control form-control-sm mt-1 p-0 px-1"
                  style="width: 85px; height: 26px; font-size: 11px" />
                } }
              </div>

              <div
                [innerHtml]="SVG_ICONS.PRESENT_MARK_ICON() | sanitizer : 'html'"
                class="cursor-pointer"
                [style.opacity]="item.attendanceStatus === 'Present' || item.attendanceStatus === 'Attend Late' ? '0.5' : '1'"
                [style.pointer-events]="item.attendanceStatus === 'Present' || item.attendanceStatus === 'Attend Late' ? 'none' : 'auto'"
                (click)="AddStudentAttendance(item, 'Present')"
                (keyup)="AddStudentAttendance(item, 'Present')"
                role="button"
                tabindex="0"
                title="Mark Present"></div>
              <div
                [innerHtml]="SVG_ICONS.ABSENT_MARK_ICON() | sanitizer : 'html'"
                class="cursor-pointer"
                [style.opacity]="item.attendanceStatus === 'Absent' ? '0.5' : '1'"
                [style.pointer-events]="item.attendanceStatus === 'Absent' ? 'none' : 'auto'"
                (click)="AddStudentAttendance(item, 'Absent')"
                (keyup)="AddStudentAttendance(item, 'Absent')"
                role="button"
                tabindex="0"
                title="Mark Absent"></div>
            </div>
          </div>

          <div class="mt-3 d-flex gap-3 flex-wrap">
            <div class="d-flex gap-1">
              <div [innerHtml]="SVG_ICONS.CAKE_ICON() | sanitizer : 'html'"></div>
              <div class="fs-12 fw-bold font-gray-opacity mt-1">{{ item.age }} yr</div>
            </div>
            <div class="d-flex gap-1">
              <div [innerHtml]="SVG_ICONS.HEIGHT_ICON(17, 17) | sanitizer : 'html'"></div>
              <div class="fs-12 fw-bold font-gray-opacity mt-1">{{ item.Height || "" }} cm</div>
            </div>
            <!-- <div class="d-flex gap-1">
              <div [innerHtml]="SVG_ICONS.MEMBERSHIP_ICON() | sanitizer : 'html'"></div>
              <div class="fs-12 fw-bold font-gray-opacity mt-1">{{ classDetails.PackageName || "-" }}</div>
            </div> -->

            @if((item.attendanceStatus === 'Present' || item.attendanceStatus === 'Attend Late') && item.isLate && !item.isEditing){
            <div class="d-flex gap-1 align-items-center">
              <span class="badge bg-warning text-dark fs-10" style="font-weight: 500">
                Late @if(item.lateTime){ &#64; {{ item.lateTime }} } @if(item.LateByMinutes){ ({{ item.LateByMinutes < 0 ? -item.LateByMinutes : item.LateByMinutes }} min) }
              </span>
            </div>
            }
          </div>
        </div>
        } @if(filteredStudentList.length === 0) {
        <div class="mt-3">
          <div class="fs-16 fw-bold font-red-light">No Students Found</div>
        </div>
        }
      </div>

      }
    </div>

    <div class="col-auto d-none d-md-flex justify-content-center">
      <div class="vr-custom"></div>
    </div>

    <div class="col-md-5 col-12">
      <div class="mt-3 d-flex justify-content-end">
        <div [innerHtml]="SVG_ICONS.CLOSE_ICON() | sanitizer : 'html'" class="cursor-pointer" (click)="onBack(ClassID)" tabindex="0" (keydown)="onBack(ClassID)"></div>
      </div>
      @if(selectedMode === 'Automatic') {
      <div class="d-flex justify-content-center">
        <img src="public/scan-face.png" alt="" />
      </div>
      } @if(selectedMode === 'Manual') {
      <div class="d-flex flex-column justify-content-center align-items-center vh-100">
        <div [innerHtml]="SVG_ICONS.MANUAL_ATTENDENCE_ICON() | sanitizer : 'html'" class="cursor-pointer mt-2"></div>
        <div class="fs-14 fw-bold mt-2 text-center">Manual Attendance is on</div>
      </div>
      }
    </div>
  </div>
</div>
